import { createBrowserHistory } from "history";

const config = { basename: "/kjop-forsikring" };

export default createBrowserHistory(config);
